export default __webpack_public_path__ + "static/media/247-somaliland.a8f83aa1.svg";